import { ITagResult } from '../types/IResponse';
import { TagRequest } from './TagRequest';

import { IAnalyticsExtConnectionSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';

export type IUpdateAnalyticsExtConnectionSettingsResult = ITagResult & IAnalyticsExtConnectionSettings;

export class UpdateAnalyticsExtConnectionSettingsRequest extends TagRequest<IAnalyticsExtConnectionSettings, IUpdateAnalyticsExtConnectionSettingsResult> {
  constructor(params: IAnalyticsExtConnectionSettings) {
    super('analyticsextensions', 'updateAnalyticsExtensionsConnection', params);
  }
}
